/* Translation dictionary — keep keys flat & namespaced by section.
   EN is the source of truth. DA is hand-translated to match Sopfie's voice. */

const en = {
  // Navbar
  "nav.my_journey": "My journey",
  "nav.services": "Services",
  "nav.testimonials": "Testimonials",
  "nav.company_training": "Company training",
  "nav.how_i_work": "How I work",
  "nav.contact": "Contact",
  "nav.client_login": "Client login",
  "nav.your_space": "Your space",
  "nav.studio": "Studio",
  "nav.sign_out": "Sign out",
  "nav.lang_label": "Language",

  // Landing — hero
  "landing.hero.overline": "A universe from the inside out",
  "landing.hero.title.a": "A body that",
  "landing.hero.title.b": "feels like home.",
  "landing.hero.title.c": "Not just looks like one.",
  "landing.hero.subtitle": "Personal training & body therapy with Sopfie — a slow, honest journey of coming home to who you are, and living the life you dream of.",
  "landing.hero.cta.pt": "Book Personal Training",
  "landing.hero.cta.bt": "Book Body Therapy",
  "landing.hero.existing": "Existing client?",
  "landing.hero.enter_space": "Enter your space →",
  "landing.hero.coming_home": "\u201cComing home to who you are.\u201d",

  // Landing — pillars
  "pillar.inside_out.title": "From the inside out",
  "pillar.inside_out.body": "We connect the inner world with the outer body — that's where fulfillment lives.",
  "pillar.no_quick_fix.title": "Not a quick fix",
  "pillar.no_quick_fix.body": "A slow journey of trust, breath and presence. You arrive when you arrive.",
  "pillar.home.title": "A body that feels like home",
  "pillar.home.body": "Strength, softness, and belonging — built together over time.",

  // Landing — Pauses
  "pauses.label": "Pauses",
  "pauses.q1": "Your body has been speaking all along. This is the work of finally listening.",
  "pauses.q1.attr": "— from the inside out",
  "pauses.q2": "You don't have to earn your body. You only have to come home to it.",
  "pauses.q2.attr": "— Sopfie",
  "pauses.q3": "Strength is not something you add. It is what emerges when you stop armouring against yourself.",
  "pauses.q3.attr": "— a quiet truth",
  "pauses.divider": "Breathe, then continue",

  // Landing — My journey
  "journey.label": "My journey",
  "journey.title.a": "I searched for happiness in my body.",
  "journey.title.b": "Then I went inside.",
  "journey.p1": "For years I tried to find peace through how my body looked — pushing, shaping, measuring. It was never enough. The fulfillment I was searching for did not live there.",
  "journey.p2": "When I began the work of meeting the inside of my body — the tension, the breath, the quiet wisdom held in tissue — and connected those two worlds, something opened. I came home.",
  "journey.p3": "That is the work I now offer as a coach and therapist: a universe born from my own becoming, held for you. A space where strength and softness meet, where you don't have to choose between feeling good and looking like yourself.",
  "journey.tag": "This is not a quick fix. It's a journey of coming home.",

  // Landing — Explore strip
  "explore.what_we_do": "What we do",
  "explore.services": "Services",
  "explore.words_clients": "Words from clients",
  "explore.testimonials": "Testimonials",
  "explore.get_in_touch": "Get in touch",
  "explore.contact": "Contact",

  // How I Work
  "hiw.overline": "How I work",
  "hiw.title.a": "A quiet look",
  "hiw.title.b": "into the practice.",
  "hiw.quote": "\u201cBefore you watch this, settle for a moment. Feel your feet. Feel your breath. This is what the work asks of you — not more effort, but more presence.\u201d",
  "hiw.caption": "Filmed inside the studio. Sound is soft — you may want headphones.",
  "hiw.pillar.listen.title": "Listen first",
  "hiw.pillar.listen.body": "We start with your body's story — tension, history, what it's been carrying.",
  "hiw.pillar.build.title": "Build slowly",
  "hiw.pillar.build.body": "Strength that belongs to you, not a protocol. We meet your nervous system where it is.",
  "hiw.pillar.home.title": "Come home",
  "hiw.pillar.home.body": "A body that feels safe, rooted, and yours — not a body you have to earn.",
  "hiw.press.label": "From the press",
  "hiw.press.subtitle": "An article about my work",
  "hiw.article.title": "Body therapy: what do you do when you practise it?",
  "hiw.article.p1": "Body therapy begins with a conversation — to understand where the client is, and what they need. I listen to what my client says, but most importantly I also listen to what their body tells me when I lay them down on the treatment bed. During the session itself I work with specific techniques, pulsations, the breath, and zone therapy — methods that help create balance in body and mind. They invite the client's nervous system to soften, so they can more easily release tension and blockages held in the body.",
  "hiw.article.p2": "On the physical level, body therapy loosens and restores flow through the body, so nourishment can be absorbed again and waste can be released. I also look at how each part of the body is connected to the rest — nothing in the body works in isolation.",
  "hiw.article.p3": "On the emotional level, I remind the client that their body remembers. Our unprocessed feelings live in our bodies as imprints in muscles and organ tissue. When we don't get to express and work through what we feel, those feelings are stored — until we finally give them the attention they need.",
  "hiw.article.link": "Read the original article on ELLE.dk",

  // Footer
  "footer.tagline": "Personal training & body therapy with Sopfie — a body that feels like home, not just looks like one.",
  "footer.reach_out": "Reach out",
  "footer.book_session": "Book a session",
  "footer.pt": "Personal Training",
  "footer.bt": "Body Therapy",
  "footer.studio": "Studio",
  "footer.made_with_care": "Made with care",

  // Common
  "common.book_first": "Book first session",
  "common.learn_more": "Learn more",
  "common.show_less": "Show less",
  "common.back_to_home": "Back to home",
  "common.share_story": "Share your own story",
  "common.stories_coming": "Stories coming soon.",
  "common.homepage": "homepage",
  "common.or_return_to": "Or return to the",
  "common.email": "Email",
  "common.password": "Password",
  "common.opening": "Opening…",
  "common.name": "Your name",
  "common.continue": "Continue",
  "common.back": "Back",

  // Login
  "login.aside.overline": "Your space",
  "login.aside.title.a": "Welcome back.",
  "login.aside.title.b": "Your personal space.",
  "login.aside.body": "Sign in to see the program Sopfie has prepared for you, write notes, and track how you're moving through the journey.",
  "login.title": "Sign in",
  "login.subtitle": "Enter your email and password.",
  "login.submit": "Enter my space",
  "login.new_here": "New here?",
  "login.option.existing.tag": "Already a client",
  "login.option.existing.title": "In-person / studio",
  "login.option.existing.body": "You already train with me — get free access to your online space.",
  "login.option.online.tag": "Become an online client",
  "login.option.online.title": "650 kr / month",
  "login.option.online.body": "Personal program, nutrition, voice coaching — all in your private space.",

  // Studio Login
  "studio.aside.overline": "Studio entrance",
  "studio.aside.title.a": "Welcome,",
  "studio.aside.title.b": "Sopfie.",
  "studio.aside.body": "Sign in to tend to your clients — their programs, their questions, their nutrition and the words they share with you.",
  "studio.title": "Studio sign in",
  "studio.subtitle": "Admin access only.",
  "studio.submit": "Enter the studio",
  "studio.opening": "Opening studio…",
  "studio.wrong_door": "This entrance is for Sopfie only. Please use the client login.",
  "studio.client_link": "Are you a client?",
  "studio.client_signin": "Client sign in →",

  // Register wizard
  "register.overline": "Create a profile",
  "register.title": "A small beginning.",
  "register.subtitle": "Make a space to follow your journey.",
  "register.step.plan": "Your plan",
  "register.step.account": "Your account",
  "register.step.about": "About you",
  "register.step.training": "Training",
  "register.step.goals": "Goals & support",
  "register.step.pay": "Payment",
  "register.step.done": "Request access",
  "register.plan.title": "Which space is for you?",
  "register.plan.sub": "Two ways to walk with Sopfie.",
  "register.plan.existing.tag": "Already a client",
  "register.plan.existing.title": "In-person / studio",
  "register.plan.existing.body": "You already train with me. Free access to your online space — no payment needed.",
  "register.plan.online.tag": "Online client",
  "register.plan.online.title": "650 kr / month",
  "register.plan.online.body": "Personal program, nutrition, voice coaching, journal — all in your private space.",
  "register.account.title": "Who are you?",
  "register.account.sub": "The basics, so we can open your space.",
  "register.account.password_hint": "Password (6+ characters)",
  "register.account.reason_label": "A few words about where you are (optional)",
  "register.account.reason_ph": "What brings you to this space today?",
  "register.about.title": "About you",
  "register.about.sub": "Let's start with the ground we stand on.",
  "register.about.age": "Age",
  "register.about.sex": "Sex",
  "register.about.sex.female": "Female",
  "register.about.sex.male": "Male",
  "register.about.sex.other": "Other",
  "register.about.height": "Height (cm)",
  "register.about.weight": "Weight (kg)",
  "register.about.family": "Family situation (children, partner…)",
  "register.about.family_ph": "e.g. married, two kids (4 & 7)",
  "register.about.work": "Work situation",
  "register.about.work_ph": "e.g. full-time office, 45h/week, sometimes travel",
  "register.about.stress": "Stress level",
  "register.about.stress.low": "Low",
  "register.about.stress.medium": "Medium",
  "register.about.stress.high": "High",
  "register.about.stress.burnout": "Burnt out",
  "register.about.sleep_quality": "Sleep quality",
  "register.about.sleep_quality.poor": "Poor",
  "register.about.sleep_quality.okay": "Okay",
  "register.about.sleep_quality.good": "Good",
  "register.about.sleep_quality.excellent": "Excellent",
  "register.about.sleep_hours": "Sleep (hours/night)",
  "register.about.menopause": "Menopause / peri-menopause",
  "register.about.conditions": "Diseases / medical conditions",
  "register.about.conditions_ph": "Anything your body lives with (diabetes, thyroid, hypertension…)",
  "register.about.injuries": "Limitations / injuries",
  "register.about.injuries_ph": "Old or current injuries I should respect in the program",
  "register.training.title": "Your training",
  "register.training.sub": "So I can meet you exactly where you are.",
  "register.training.bg": "Training background",
  "register.training.bg_ph": "e.g. beginner / crossfit 2 years / runner",
  "register.training.history": "Training history — tell the story",
  "register.training.history_ph": "What have you done, what worked, what didn't — anything you want me to know.",
  "register.training.days": "Days per week you can train",
  "register.training.location": "Where do you train?",
  "register.training.location.gym": "Gym",
  "register.training.location.home": "At home",
  "register.training.location.both": "Both",
  "register.training.location.outdoor": "Outdoor",
  "register.training.equipment": "Equipment you have access to",
  "register.training.equipment_ph": "e.g. full gym, or at home: a pair of dumbbells up to 20kg, a bench, resistance bands — or no equipment at all.",
  "register.goals.title": "Goals & how I can support you",
  "register.goals.sub": "What you want — and what has stood in the way before.",
  "register.goals.goal": "Your goal",
  "register.goals.goal_ph": "Say it plainly — fat loss, strength, feeling at home in my body…",
  "register.goals.obstacles": "What has stopped you from reaching it before?",
  "register.goals.obstacles_ph": "Be honest — time, motivation, injury, self-trust, the way it was taught…",
  "register.goals.learning": "How do you learn best?",
  "register.goals.learning.visual": "Visually (video, images, demos)",
  "register.goals.learning.verbal": "Verbally (clear spoken cues)",
  "register.goals.learning.hands_on": "Hands-on (feeling my body do it)",
  "register.goals.learning.analytical": "Analytically (numbers, reasons)",
  "register.goals.learning.mixed": "A bit of everything",
  "register.goals.food": "Relationship with food — struggles?",
  "register.goals.food_ph": "e.g. emotional eating, skipping meals, snacking at night",
  "register.goals.habits": "Bad habits you want to shift",
  "register.goals.habits_ph": "Smoking, late nights, sugar crashes…",
  "register.goals.support": "How will you feel most supported by me?",
  "register.goals.support_ph": "e.g. weekly check-ins, firm accountability, warm encouragement, lots of voice notes…",
  "register.goals.allergies": "Allergies (optional)",
  "register.pay.title": "One last step.",
  "register.pay.sub": "Your first month of online coaching.",
  "register.pay.plan_name": "Online coaching",
  "register.pay.per_month": "DKK / month",
  "register.pay.bullet1": "Personal program — adapted to your intake",
  "register.pay.bullet2": "Warm-up, nutrition plan, AI Sopfie chat",
  "register.pay.bullet3": "Voice-guided workouts in my cloned voice",
  "register.pay.bullet4": "Private folder to share questions, feedback, progressions",
  "register.pay.footnote": "After payment, I'll review your intake and approve your space within a day. You'll receive an email when your space is ready.",
  "register.pay.submit": "Pay 650 DKK & continue",
  "register.pay.opening": "Opening checkout…",
  "register.pay.secure": "Secure checkout via Stripe. Card or MobilePay.",
  "register.done.title": "Almost there.",
  "register.done.sub": "Confirm and I'll welcome you in.",
  "register.done.submit": "Request access",
  "register.done.sending": "Sending request…",
  "register.pending.title": "Request received.",
  "register.pending.tagline": "You'll be able to sign in as soon as Sopfie approves your access.",
  "register.pending.back": "Back to homepage",
  "register.pending.signin": "Go to sign in",
  "register.already": "Already a client?",
  "register.already.signin": "Sign in",

  // Payment return
  "payment.checking.title": "Confirming your payment…",
  "payment.checking.body": "Hang on a moment while Stripe settles things.",
  "payment.paid.title": "Welcome in.",
  "payment.paid.body": "Your payment is complete — thank you. I'm reviewing your intake and will open your space within a day. You'll receive an email as soon as you can sign in.",
  "payment.expired.title": "This session expired.",
  "payment.expired.body": "No charge was made. You're welcome to start again.",
  "payment.expired.cta": "Start over",
  "payment.failed.title": "We're still waiting on confirmation.",
  "payment.failed.body": "Your payment may still go through. Check your email — if you've been charged, sign in will open once Sopfie approves you.",
  "payment.error.title": "Something went wrong.",
  "payment.error.fallback": "Please try again.",
  "payment.error.cta": "Back to sign up",
  "payment.error.missing": "Missing payment session.",

  // Public Book (shared link page)
  "book.public.title": "Personal Book",
  "book.public.loading": "Opening the book…",
  "book.public.revoked.title": "This link is no longer active.",
  "book.public.owner_journey": "'s journey.",
  "book.public.pictures": "picture",
  "book.public.pictures_plural": "pictures",
  "book.public.entries": "journal entry",
  "book.public.entries_plural": "journal entries",
  "book.public.download": "Download as PDF",
  "book.public.footer": "Shared privately via YouFit by Sopfie · a body that feels like home.",

  // Footer

  // Services
  "services.overline": "What we do together",
  "services.title.a": "Two doors.",
  "services.title.b": "Same home.",
  "services.lead": "Choose where you want to begin. Each path is part of the same coming-home — and they often weave together.",
  "services.pt.tag": "01 · Personal Training",
  "services.pt.title": "Strength training",
  "services.pt.summary": "Programs built around your body, your week, your dream of how you want to feel. Movement that builds capacity without abandoning softness.",
  "services.pt.long.intro": "This isn't just personal training. It's a space where your body, your life, and your story are all taken seriously.",
  "services.pt.long.p1": "When you work with me, we don't start with a generic plan or a fixed idea of what you \"should\" be. We start with you — your goals, your background, your routines, your pressures, your history with movement, and how you actually want to feel in your body and your life. Because your body doesn't exist in isolation.",
  "services.pt.long.p2": "The way you move, the way you carry tension, your energy levels — it's all shaped by your experiences, your work, your relationships, your past. I take all of that into account, not as an afterthought, but as the foundation of how we build your training.",
  "services.pt.long.p3": "Together, we create something that fits into your real life. A plan that supports your schedule, respects your limitations, and evolves with you as you grow. This is not about pushing you into someone else's system. It's about building one that actually works for you.",
  "services.pt.long.p4": "Our focus goes beyond aesthetics. Wanting to change how your body looks is completely normal, but beyond that, we focus on how you feel in your body: strong, capable, confident, and at peace. Movement becomes something that supports you, not something you fight against or force yourself through.",
  "services.pt.long.p5": "You'll learn to understand your body — how it responds, what it needs, where it holds stress, and how to build both strength and flexibility at the same time. You'll begin to recognise patterns, not just physically, but mentally and emotionally too, because real, lasting change isn't just physical.",
  "services.pt.long.p6": "Training with me is not a quick fix or a short-term push. It's a process, a partnership, and an investment in yourself — in your energy, your resilience, your self-awareness, and the way you show up in your life. There will be structure, but also flexibility; challenge, but also compassion; and progress, but on your body's terms.",
  "services.pt.long.outro": "This is about coming back to yourself — to a body you trust, to a sense of strength that feels grounded rather than forced, and to a way of moving and living that actually feels sustainable.",
  "services.pt.long.cta": "If you're ready for something deeper than just another program, this is where we begin.",
  "services.bt.tag": "02 · Body Therapy",
  "services.bt.title": "Releasing what was held",
  "services.bt.summary": "Hands-on work that meets the body where words don't reach. Tension softens. Breath returns. You remember you are home.",
  "services.bt.long.intro": "This isn't just body therapy. It's a space where you're invited to get out of your head and come back into your body.",
  "services.bt.long.p1": "Many of us move through life by thinking, analysing, and pushing forward without fully feeling or processing what's happening inside. Over time, what we don't express or give space to doesn't disappear. It settles in the body. It can show up as tension, discomfort, limitations, or a quiet sense of disconnection from yourself.",
  "services.bt.long.p2": "This work is about gently meeting those layers.",
  "services.bt.long.p3": "When you come to me, we create a space built on trust and safety. There is no expectation to be anything other than where you are. Through touch, pressure, breath, and really listening to what your body is communicating, we start to bring awareness to what needs attention.",
  "services.bt.long.quote": "Your body already knows what it's holding. My role is to help you listen to it.",
  "services.bt.long.p4": "Together, we work with what's been stored so the body can slowly start to let go. Space opens where there was tightness, and a sense of lightness and calm can begin to return. This isn't about fixing anything, but about allowing your body to shift in its own way, at its own pace.",
  "services.bt.long.p5": "Over time, this changes your relationship with your body. It stops being something you have to manage or push through, and starts becoming a place you can actually trust. A place that feels safer, more grounded, and more like home in your everyday life.",
  "services.bt.long.p6": "This is for anyone who feels ready to invest in themselves in a deeper way. Your body has carried you through everything you've lived. This is a way of giving something back to it.",
  "services.bt.long.p7": "You don't need to have it all figured out before starting. Just a willingness to meet yourself where you are.",
  "services.bt.long.outro": "I'm here to support you in that process, as you reconnect, release, and slowly come home to yourself.",
  "services.company.tag": "03 · Company Training",
  "services.company.title": "For teams & companies",
  "services.company.body": "Together with my colleague Anthony, we have built a universe for companies who want to invest in their employees — to optimise performance, lower sick days and give their people a body free of limitations. A living practice that travels with your team through their working week.",

  // Testimonials
  "testimonials.overline": "Testimonials",
  "testimonials.title": "Words from the people I've walked with.",
  "testimonials.lead": "Each story is its own. Each homecoming, different. These are some of the experiences clients have shared with me.",

  // Contact
  "contact.overline": "If something stirred",
  "contact.title.a": "Reach out.",
  "contact.title.b": "I'd love to hear from you.",
  "contact.lead": "Write to me, call me, or book your first session directly.",
  "contact.loc.pt.label": "Personal training",
  "contact.loc.pt.name": "Fitness X Frederiksberg",
  "contact.loc.pt.body": "Where we train together — strength, mobility, presence.",
  "contact.loc.bt.label": "Body therapy clinic",
  "contact.loc.bt.name": "Gammel Kongevej 109",
  "contact.loc.bt.city": "Frederiksberg",
  "contact.loc.bt.body": "The clinic — hands-on body therapy and nervous-system work.",

  // Company Training
  "company.hero.overline": "For teams & companies",
  "company.hero.title.a": "A unique opportunity to invest in your",
  "company.hero.title.b": "people's health & mental wealth.",
  "company.hero.p1.a": "Together with my colleague",
  "company.hero.p1.b": "we have built a universe for companies who want to do more than offer a fruit basket — companies who want their people to feel strong, calm, and clear.",
  "company.hero.p2": "We share a similar vision: not just helping people look good, but giving them a body free of limitations — one that feels safe, and like home.",
  "company.why.overline": "Why us, why now",
  "company.why.title": "What we create together — for your team.",
  "company.why.p1": "As a team — Anthony and I — we create a unique opportunity for companies to invest in their employees' health and mental well-being. Not a one-off workshop. Not a static gym discount. A living practice that travels with your people through their working week.",
  "company.why.p2": "When the people who carry your company feel grounded in their body, the whole environment shifts: a better company culture, healthier employees who contribute to better performance, more energy, sharper focus — and meaningfully fewer sick days.",
  "company.offer.overline": "What's inside",
  "company.offer.title": "A practice your whole team can come home to — wherever they work from.",
  "company.offer.c1.title": "Online sessions",
  "company.offer.c1.body": "Designed around each person — their goal, limitations, stress level, availability, lifestyle, and whether they train in a gym or at home.",
  "company.offer.c2.title": "Strength, mobility & nervous-system",
  "company.offer.c2.body": "Strength, mobility, and nervous system support, designed for bodies that spend long hours sitting and carrying stress. We focus on building real, lasting resilience that actually shows up in your everyday life.",
  "company.offer.c3.title": "Two coaches, one philosophy",
  "company.offer.c3.body": "Together, we bring over 20 years of experience in coaching and personal training, have helped more than 80,000 clients, and continue to grow, both as individuals and coaches, to offer the highest level of expertise and guidance.",
  "company.addon.overline": "Optional add-on",
  "company.addon.title.a": "Want us in the room?",
  "company.addon.title.b": "Book us in person.",
  "company.addon.body": "On top of the online programme, your company can buy us to come and train your team in person — at your office, at an off-site, or at a wellness day. This is an add-on to the online universe, priced separately based on travel and group size.",
  "company.addon.cta": "Ask about in-person",
  "company.outcomes.overline": "What it brings",
  "company.outcomes.title.a": "Performance that lasts.",
  "company.outcomes.title.b": "Sick days that don't.",
  "company.outcomes.li1": "Better company environment — more present people, less burnout",
  "company.outcomes.li2": "Healthier employees — improved energy, focus and mood",
  "company.outcomes.li3": "Stronger performance and contribution at every level",
  "company.outcomes.li4": "Fewer sick days, stronger retention, happier teams",
  "company.contact.overline": "Bring us in",
  "company.contact.title": "Ready to invest in your people?",
  "company.contact.lead": "Reach either of us — Sopfie or Anthony — to talk about your team and what would serve them best.",
  "company.contact.cta": "Enquire for your team",
};

const da = {
  // Navbar
  "nav.my_journey": "Min rejse",
  "nav.services": "Ydelser",
  "nav.testimonials": "Anbefalinger",
  "nav.company_training": "Virksomhedstræning",
  "nav.how_i_work": "Sådan arbejder jeg",
  "nav.contact": "Kontakt",
  "nav.client_login": "Klient login",
  "nav.your_space": "Dit rum",
  "nav.studio": "Studie",
  "nav.sign_out": "Log ud",
  "nav.lang_label": "Sprog",

  // Landing — hero
  "landing.hero.overline": "Et univers indefra og ud",
  "landing.hero.title.a": "En krop der",
  "landing.hero.title.b": "føles som hjem.",
  "landing.hero.title.c": "Ikke bare ser sådan ud.",
  "landing.hero.subtitle": "Personlig træning og kropsterapi med Sopfie — en langsom, ærlig rejse hjem til den du er, og det liv du drømmer om.",
  "landing.hero.cta.pt": "Book Personlig Træning",
  "landing.hero.cta.bt": "Book Kropsterapi",
  "landing.hero.existing": "Eksisterende klient?",
  "landing.hero.enter_space": "Gå ind i dit rum →",
  "landing.hero.coming_home": "\u201cKom hjem til den du er.\u201d",

  // Landing — pillars
  "pillar.inside_out.title": "Indefra og ud",
  "pillar.inside_out.body": "Vi forbinder den indre verden med den ydre krop — det er der opfyldelsen bor.",
  "pillar.no_quick_fix.title": "Ingen hurtig løsning",
  "pillar.no_quick_fix.body": "En langsom rejse af tillid, åndedræt og nærvær. Du ankommer, når du ankommer.",
  "pillar.home.title": "En krop der føles som hjem",
  "pillar.home.body": "Styrke, blødhed og tilhør — bygget sammen over tid.",

  // Landing — Pauses
  "pauses.label": "Pauser",
  "pauses.q1": "Din krop har talt hele tiden. Dette er arbejdet med endelig at lytte.",
  "pauses.q1.attr": "— indefra og ud",
  "pauses.q2": "Du behøver ikke at gøre dig fortjent til din krop. Du skal bare komme hjem til den.",
  "pauses.q2.attr": "— Sopfie",
  "pauses.q3": "Styrke er ikke noget du tilføjer. Det er det, der træder frem, når du holder op med at panse dig selv ind.",
  "pauses.q3.attr": "— en stille sandhed",
  "pauses.divider": "Træk vejret, og fortsæt",

  // Landing — My journey
  "journey.label": "Min rejse",
  "journey.title.a": "Jeg ledte efter lykken i min krop.",
  "journey.title.b": "Så gik jeg indenfor.",
  "journey.p1": "I mange år forsøgte jeg at finde fred gennem hvordan min krop så ud — pressede, formede, målte. Det var aldrig nok. Den opfyldelse jeg ledte efter, boede ikke der.",
  "journey.p2": "Da jeg begyndte at møde min krop indefra — spændingerne, åndedrættet, den stille visdom der ligger gemt i vævet — og forbandt de to verdener, åbnede noget sig. Jeg kom hjem.",
  "journey.p3": "Det er det arbejde jeg nu tilbyder som coach og terapeut: et univers født af min egen forvandling, holdt for dig. Et rum hvor styrke og blødhed mødes, hvor du ikke behøver at vælge mellem at have det godt og ligne dig selv.",
  "journey.tag": "Dette er ingen hurtig løsning. Det er en rejse hjem.",

  // Landing — Explore strip
  "explore.what_we_do": "Hvad vi gør",
  "explore.services": "Ydelser",
  "explore.words_clients": "Ord fra klienter",
  "explore.testimonials": "Anbefalinger",
  "explore.get_in_touch": "Tag kontakt",
  "explore.contact": "Kontakt",

  // How I Work
  "hiw.overline": "Sådan arbejder jeg",
  "hiw.title.a": "Et stille blik",
  "hiw.title.b": "ind i praksissen.",
  "hiw.quote": "\u201cFør du ser det her, så fald lige til ro et øjeblik. Mærk dine fødder. Mærk dit åndedræt. Det er det, arbejdet beder om — ikke mere anstrengelse, men mere nærvær.\u201d",
  "hiw.caption": "Filmet inde i studiet. Lyden er blid — hovedtelefoner anbefales.",
  "hiw.pillar.listen.title": "Lyt først",
  "hiw.pillar.listen.body": "Vi begynder med din krops historie — spændinger, fortid, det den har båret på.",
  "hiw.pillar.build.title": "Byg langsomt",
  "hiw.pillar.build.body": "Styrke der tilhører dig, ikke en protokol. Vi møder dit nervesystem der hvor det er.",
  "hiw.pillar.home.title": "Kom hjem",
  "hiw.pillar.home.body": "En krop der føles tryg, rodfæstet og din egen — ikke en krop du skal gøre dig fortjent til.",
  "hiw.press.label": "Fra pressen",
  "hiw.press.subtitle": "En artikel om mit arbejde",
  "hiw.article.title": "Kropsterapi: Hvad gør du, når du udøver det?",
  "hiw.article.p1": "Kropsterapi foregår ved først at have en samtale for at få forstå, hvor klienten er, og hvad den har brug for. Jeg lytter til, hvad min klient siger, men vigtigst af alt også hvad deres krop fortæller mig, når jeg ligger dem på briksen. Under selve behandlingen arbejder jeg med specifikke teknikker, pulseringer, åndedrættet og zoneterapi, som er med til at skabe balance i krop og sind. Disse metoder vil hjælpe klientens nervesystem til at slappe af, så de lettere kan slippe spændinger og blokeringer i kroppen.",
  "hiw.article.p2": "Kropsterapien på det fysiske plan vil løsne og skabe gennemstrøm i kroppen, så næring igen kan optages og affaldsstofferne udskilles. Derudover vil jeg kigge på de enkelte kropsdeles sammenhæng med resten af kroppen.",
  "hiw.article.p3": "På det psykiske plan minder jeg klienten om, at deres krop husker. I vores krop ligger vores uforløste følelser som aftryk i muskler og organvæv. Det betyder, at når vi ikke får udtrykt og bearbejdet vores følelser, så lagres de i kroppen, indtil vi giver dem den opmærksomhed, de behøver.",
  "hiw.article.link": "Læs den oprindelige artikel på ELLE.dk",

  // Footer
  "footer.tagline": "Personlig træning og kropsterapi med Sopfie — en krop der føles som hjem, ikke bare ser sådan ud.",
  "footer.reach_out": "Tag kontakt",
  "footer.book_session": "Book en session",
  "footer.pt": "Personlig Træning",
  "footer.bt": "Kropsterapi",
  "footer.studio": "Studie",
  "footer.made_with_care": "Lavet med omsorg",

  // Common
  "common.book_first": "Book første session",
  "common.learn_more": "Læs mere",
  "common.show_less": "Vis mindre",
  "common.back_to_home": "Tilbage til forsiden",
  "common.share_story": "Del din egen historie",
  "common.stories_coming": "Historier på vej.",
  "common.homepage": "forsiden",
  "common.or_return_to": "Eller vend tilbage til",
  "common.email": "E-mail",
  "common.password": "Adgangskode",
  "common.opening": "Åbner…",
  "common.name": "Dit navn",
  "common.continue": "Fortsæt",
  "common.back": "Tilbage",

  // Login
  "login.aside.overline": "Dit rum",
  "login.aside.title.a": "Velkommen tilbage.",
  "login.aside.title.b": "Dit personlige rum.",
  "login.aside.body": "Log ind for at se det program Sopfie har lavet til dig, skrive noter og følge hvordan du bevæger dig gennem rejsen.",
  "login.title": "Log ind",
  "login.subtitle": "Indtast din e-mail og adgangskode.",
  "login.submit": "Gå ind i mit rum",
  "login.new_here": "Ny her?",
  "login.option.existing.tag": "Allerede klient",
  "login.option.existing.title": "Personligt fremmøde / studie",
  "login.option.existing.body": "Du træner allerede med mig — få gratis adgang til dit online rum.",
  "login.option.online.tag": "Bliv online-klient",
  "login.option.online.title": "650 kr / måned",
  "login.option.online.body": "Personligt program, ernæring, stemmecoaching — alt i dit private rum.",

  // Studio Login
  "studio.aside.overline": "Studie-indgang",
  "studio.aside.title.a": "Velkommen,",
  "studio.aside.title.b": "Sopfie.",
  "studio.aside.body": "Log ind for at tage dig af dine klienter — deres programmer, deres spørgsmål, deres ernæring og de ord, de deler med dig.",
  "studio.title": "Studie-login",
  "studio.subtitle": "Kun for administrator.",
  "studio.submit": "Gå ind i studiet",
  "studio.opening": "Åbner studiet…",
  "studio.wrong_door": "Denne indgang er kun for Sopfie. Brug venligst klient-login.",
  "studio.client_link": "Er du klient?",
  "studio.client_signin": "Klient-login →",

  // Register wizard
  "register.overline": "Opret en profil",
  "register.title": "En lille begyndelse.",
  "register.subtitle": "Skab et rum til at følge din rejse.",
  "register.step.plan": "Din plan",
  "register.step.account": "Din konto",
  "register.step.about": "Om dig",
  "register.step.training": "Træning",
  "register.step.goals": "Mål & støtte",
  "register.step.pay": "Betaling",
  "register.step.done": "Anmod om adgang",
  "register.plan.title": "Hvilket rum er for dig?",
  "register.plan.sub": "To måder at gå sammen med Sopfie.",
  "register.plan.existing.tag": "Allerede klient",
  "register.plan.existing.title": "Personligt fremmøde / studie",
  "register.plan.existing.body": "Du træner allerede med mig. Gratis adgang til dit online rum — ingen betaling påkrævet.",
  "register.plan.online.tag": "Online-klient",
  "register.plan.online.title": "650 kr / måned",
  "register.plan.online.body": "Personligt program, ernæring, stemmecoaching, journal — alt i dit private rum.",
  "register.account.title": "Hvem er du?",
  "register.account.sub": "De basale ting, så vi kan åbne dit rum.",
  "register.account.password_hint": "Adgangskode (6+ tegn)",
  "register.account.reason_label": "Et par ord om hvor du er (valgfrit)",
  "register.account.reason_ph": "Hvad bringer dig til dette rum i dag?",
  "register.about.title": "Om dig",
  "register.about.sub": "Lad os begynde med den grund vi står på.",
  "register.about.age": "Alder",
  "register.about.sex": "Køn",
  "register.about.sex.female": "Kvinde",
  "register.about.sex.male": "Mand",
  "register.about.sex.other": "Andet",
  "register.about.height": "Højde (cm)",
  "register.about.weight": "Vægt (kg)",
  "register.about.family": "Familiesituation (børn, partner…)",
  "register.about.family_ph": "fx gift, to børn (4 & 7)",
  "register.about.work": "Arbejdssituation",
  "register.about.work_ph": "fx fuldtid kontor, 45t/uge, rejser nogle gange",
  "register.about.stress": "Stressniveau",
  "register.about.stress.low": "Lavt",
  "register.about.stress.medium": "Middel",
  "register.about.stress.high": "Højt",
  "register.about.stress.burnout": "Udbrændt",
  "register.about.sleep_quality": "Søvnkvalitet",
  "register.about.sleep_quality.poor": "Dårlig",
  "register.about.sleep_quality.okay": "OK",
  "register.about.sleep_quality.good": "God",
  "register.about.sleep_quality.excellent": "Fremragende",
  "register.about.sleep_hours": "Søvn (timer/nat)",
  "register.about.menopause": "Overgangsalder",
  "register.about.conditions": "Sygdomme / medicinske tilstande",
  "register.about.conditions_ph": "Alt det din krop lever med (diabetes, stofskifte, forhøjet blodtryk…)",
  "register.about.injuries": "Begrænsninger / skader",
  "register.about.injuries_ph": "Gamle eller nuværende skader jeg skal tage hensyn til i programmet",
  "register.training.title": "Din træning",
  "register.training.sub": "Så jeg kan møde dig præcis der hvor du er.",
  "register.training.bg": "Træningsbaggrund",
  "register.training.bg_ph": "fx begynder / crossfit 2 år / løber",
  "register.training.history": "Træningshistorie — fortæl historien",
  "register.training.history_ph": "Hvad har du gjort, hvad virkede, hvad virkede ikke — alt jeg bør vide.",
  "register.training.days": "Dage om ugen du kan træne",
  "register.training.location": "Hvor træner du?",
  "register.training.location.gym": "Center",
  "register.training.location.home": "Hjemme",
  "register.training.location.both": "Begge",
  "register.training.location.outdoor": "Udendørs",
  "register.training.equipment": "Udstyr du har adgang til",
  "register.training.equipment_ph": "fx fuldt center, eller hjemme: et par håndvægte op til 20 kg, en bænk, elastikker — eller intet udstyr.",
  "register.goals.title": "Mål & hvordan jeg kan støtte dig",
  "register.goals.sub": "Hvad du vil — og hvad der har stået i vejen før.",
  "register.goals.goal": "Dit mål",
  "register.goals.goal_ph": "Sig det ligeud — fedttab, styrke, at føle mig hjemme i min krop…",
  "register.goals.obstacles": "Hvad har stoppet dig i at nå det før?",
  "register.goals.obstacles_ph": "Vær ærlig — tid, motivation, skader, mistillid til dig selv, måden det blev lært på…",
  "register.goals.learning": "Hvordan lærer du bedst?",
  "register.goals.learning.visual": "Visuelt (video, billeder, demoer)",
  "register.goals.learning.verbal": "Verbalt (klare talte cues)",
  "register.goals.learning.hands_on": "Hands-on (mærke min krop gøre det)",
  "register.goals.learning.analytical": "Analytisk (tal, grunde)",
  "register.goals.learning.mixed": "Lidt af det hele",
  "register.goals.food": "Forhold til mad — kampe?",
  "register.goals.food_ph": "fx følelsesspisning, springer måltider over, snacking om natten",
  "register.goals.habits": "Dårlige vaner du vil ændre",
  "register.goals.habits_ph": "Rygning, sene aftner, sukkernedture…",
  "register.goals.support": "Hvordan vil du føle dig mest støttet af mig?",
  "register.goals.support_ph": "fx ugentlige check-ins, fast ansvar, varm opmuntring, mange stemmebeskeder…",
  "register.goals.allergies": "Allergier (valgfrit)",
  "register.pay.title": "Et sidste skridt.",
  "register.pay.sub": "Din første måned med online-coaching.",
  "register.pay.plan_name": "Online-coaching",
  "register.pay.per_month": "DKK / måned",
  "register.pay.bullet1": "Personligt program — tilpasset din intake",
  "register.pay.bullet2": "Opvarmning, kostplan, AI Sopfie-chat",
  "register.pay.bullet3": "Stemme-guidet træning i min klonede stemme",
  "register.pay.bullet4": "Privat mappe til at dele spørgsmål, feedback og progressioner",
  "register.pay.footnote": "Efter betaling gennemgår jeg din intake og åbner dit rum inden for en dag. Du modtager en e-mail når dit rum er klar.",
  "register.pay.submit": "Betal 650 DKK & fortsæt",
  "register.pay.opening": "Åbner checkout…",
  "register.pay.secure": "Sikker betaling via Stripe. Kort eller MobilePay.",
  "register.done.title": "Næsten der.",
  "register.done.sub": "Bekræft, så byder jeg dig velkommen.",
  "register.done.submit": "Anmod om adgang",
  "register.done.sending": "Sender anmodning…",
  "register.pending.title": "Anmodning modtaget.",
  "register.pending.tagline": "Du kan logge ind så snart Sopfie har godkendt din adgang.",
  "register.pending.back": "Tilbage til forsiden",
  "register.pending.signin": "Gå til login",
  "register.already": "Allerede klient?",
  "register.already.signin": "Log ind",

  // Payment return
  "payment.checking.title": "Bekræfter din betaling…",
  "payment.checking.body": "Et øjeblik mens Stripe afslutter.",
  "payment.paid.title": "Velkommen indenfor.",
  "payment.paid.body": "Din betaling er gennemført — tak. Jeg gennemgår din intake og åbner dit rum inden for en dag. Du modtager en e-mail så snart du kan logge ind.",
  "payment.expired.title": "Denne session er udløbet.",
  "payment.expired.body": "Der blev ikke trukket noget. Du er velkommen til at starte forfra.",
  "payment.expired.cta": "Start forfra",
  "payment.failed.title": "Vi venter stadig på bekræftelse.",
  "payment.failed.body": "Din betaling går måske stadig igennem. Tjek din e-mail — hvis du er blevet trukket, åbner login når Sopfie har godkendt dig.",
  "payment.error.title": "Noget gik galt.",
  "payment.error.fallback": "Prøv venligst igen.",
  "payment.error.cta": "Tilbage til tilmelding",
  "payment.error.missing": "Manglende betalingssession.",

  // Public Book (shared link page)
  "book.public.title": "Personlig Bog",
  "book.public.loading": "Åbner bogen…",
  "book.public.revoked.title": "Dette link er ikke længere aktivt.",
  "book.public.owner_journey": "s rejse.",
  "book.public.pictures": "billede",
  "book.public.pictures_plural": "billeder",
  "book.public.entries": "journalpost",
  "book.public.entries_plural": "journalposter",
  "book.public.download": "Download som PDF",
  "book.public.footer": "Delt privat via YouFit by Sopfie · en krop der føles som hjem.",

  // Footer

  // Services
  "services.overline": "Hvad vi gør sammen",
  "services.title.a": "To døre.",
  "services.title.b": "Samme hjem.",
  "services.lead": "Vælg hvor du vil begynde. Hver vej er en del af den samme hjemkomst — og de fletter sig ofte sammen.",
  "services.pt.tag": "01 · Personlig Træning",
  "services.pt.title": "Styrketræning",
  "services.pt.summary": "Programmer bygget op om din krop, din uge, din drøm om hvordan du vil have det. Bevægelse der bygger kapacitet uden at glemme det bløde.",
  "services.pt.long.intro": "Det her er ikke bare personlig træning. Det er et rum hvor din krop, dit liv og din historie alle bliver taget alvorligt.",
  "services.pt.long.p1": "Når du arbejder med mig, starter vi ikke med en generisk plan eller en fast idé om hvad du \"burde\" være. Vi starter med dig — dine mål, din baggrund, dine rutiner, dine pres, din historie med bevægelse, og hvordan du faktisk gerne vil have det i din krop og dit liv. For din krop findes ikke i isolation.",
  "services.pt.long.p2": "Måden du bevæger dig på, måden du bærer spændinger, dit energiniveau — det hele er formet af dine oplevelser, dit arbejde, dine relationer, din fortid. Jeg tager det hele med — ikke som en eftertanke, men som fundamentet for hvordan vi bygger din træning.",
  "services.pt.long.p3": "Sammen skaber vi noget der passer ind i dit virkelige liv. En plan der støtter din kalender, respekterer dine begrænsninger, og udvikler sig med dig efterhånden som du vokser. Det handler ikke om at presse dig ind i en andens system. Det handler om at bygge ét der faktisk virker for dig.",
  "services.pt.long.p4": "Vores fokus rækker ud over æstetikken. Det er helt normalt at ville ændre hvordan kroppen ser ud, men ud over det fokuserer vi på hvordan du føler i din krop: stærk, dygtig, sikker og i fred. Bevægelse bliver noget der støtter dig, ikke noget du kæmper imod eller tvinger dig selv igennem.",
  "services.pt.long.p5": "Du lærer at forstå din krop — hvordan den reagerer, hvad den har brug for, hvor den holder stress, og hvordan man bygger både styrke og fleksibilitet på samme tid. Du begynder at genkende mønstre, ikke kun fysisk men også mentalt og følelsesmæssigt — for ægte, varig forandring er ikke kun fysisk.",
  "services.pt.long.p6": "Træning med mig er ingen hurtig løsning eller kort spurt. Det er en proces, et partnerskab, en investering i dig selv — i din energi, din modstandskraft, dit selvkendskab, og måden du møder dit liv på. Der bliver struktur, men også fleksibilitet; udfordring, men også medfølelse; og fremskridt, men på din krops præmisser.",
  "services.pt.long.outro": "Det her handler om at komme tilbage til dig selv — til en krop du stoler på, til en styrke der føles jordbundet i stedet for tvunget, og til en måde at bevæge sig og leve på der faktisk føles bæredygtig.",
  "services.pt.long.cta": "Hvis du er klar til noget dybere end endnu et program, er det her vi begynder.",
  "services.bt.tag": "02 · Kropsterapi",
  "services.bt.title": "At slippe det der var holdt fast",
  "services.bt.summary": "Hænder der møder kroppen der hvor ord ikke når. Spændinger blødgøres. Åndedrættet vender tilbage. Du husker du er hjemme.",
  "services.bt.long.intro": "Det her er ikke bare kropsterapi. Det er et rum hvor du inviteres til at komme ud af hovedet og tilbage i kroppen.",
  "services.bt.long.p1": "Mange af os bevæger os gennem livet ved at tænke, analysere og presse fremad uden at føle eller bearbejde det der sker indeni. Med tiden forsvinder det vi ikke udtrykker eller giver plads ikke. Det sætter sig i kroppen. Det kan vise sig som spændinger, ubehag, begrænsninger eller en stille fornemmelse af afkobling fra dig selv.",
  "services.bt.long.p2": "Det her arbejde handler om blidt at møde de lag.",
  "services.bt.long.p3": "Når du kommer til mig, skaber vi et rum bygget på tillid og tryghed. Der er ingen forventning om at være andet end der hvor du er. Gennem berøring, tryk, åndedræt, og ved virkelig at lytte til hvad din krop kommunikerer, begynder vi at bringe opmærksomhed til det der har brug for det.",
  "services.bt.long.quote": "Din krop ved allerede hvad den holder fast på. Min rolle er at hjælpe dig med at lytte til den.",
  "services.bt.long.p4": "Sammen arbejder vi med det der er gemt, så kroppen langsomt kan begynde at slippe. Der åbner sig plads hvor der var stramhed, og en fornemmelse af lethed og ro kan begynde at vende tilbage. Det handler ikke om at reparere noget, men om at lade kroppen flytte sig på sin egen måde, i sit eget tempo.",
  "services.bt.long.p5": "Med tiden ændrer det dit forhold til din krop. Den holder op med at være noget du skal håndtere eller presse dig igennem, og bliver et sted du faktisk kan stole på. Et sted der føles tryggere, mere jordbundet og mere som hjem i din hverdag.",
  "services.bt.long.p6": "Det er for enhver der føler sig klar til at investere i sig selv på en dybere måde. Din krop har båret dig gennem alt det du har levet. Det her er en måde at give noget tilbage til den på.",
  "services.bt.long.p7": "Du behøver ikke have alt klargjort før du starter. Bare en vilje til at møde dig selv der hvor du er.",
  "services.bt.long.outro": "Jeg er her for at støtte dig i den proces, mens du forbinder dig igen, slipper, og langsomt kommer hjem til dig selv.",
  "services.company.tag": "03 · Virksomhedstræning",
  "services.company.title": "Til teams & virksomheder",
  "services.company.body": "Sammen med min kollega Anthony har vi bygget et univers til virksomheder der vil investere i deres medarbejdere — for at optimere præstation, sænke sygedage og give deres folk en krop fri af begrænsninger. En levende praksis der følger jeres team gennem arbejdsugen.",

  // Testimonials
  "testimonials.overline": "Anbefalinger",
  "testimonials.title": "Ord fra dem jeg har gået ved siden af.",
  "testimonials.lead": "Hver historie er sin egen. Hver hjemkomst, anderledes. Her er nogle af de oplevelser klienter har delt med mig.",

  // Contact
  "contact.overline": "Hvis noget rørte sig",
  "contact.title.a": "Tag kontakt.",
  "contact.title.b": "Jeg vil meget gerne høre fra dig.",
  "contact.lead": "Skriv til mig, ring til mig, eller book din første session direkte.",
  "contact.loc.pt.label": "Personlig træning",
  "contact.loc.pt.name": "Fitness X Frederiksberg",
  "contact.loc.pt.body": "Her træner vi sammen — styrke, mobilitet, nærvær.",
  "contact.loc.bt.label": "Kropsterapi-klinik",
  "contact.loc.bt.name": "Gammel Kongevej 109",
  "contact.loc.bt.city": "Frederiksberg",
  "contact.loc.bt.body": "Klinikken — hands-on kropsterapi og nervesystem-arbejde.",

  // Company Training
  "company.hero.overline": "Til teams & virksomheder",
  "company.hero.title.a": "En enestående mulighed for at investere i jeres",
  "company.hero.title.b": "menneskers sundhed & mentale velvære.",
  "company.hero.p1.a": "Sammen med min kollega",
  "company.hero.p1.b": "har vi bygget et univers til virksomheder der vil mere end at tilbyde en frugtkurv — virksomheder der vil have deres folk til at føle sig stærke, rolige og klare.",
  "company.hero.p2": "Vi deler en lignende vision: ikke bare at hjælpe folk med at se godt ud, men at give dem en krop fri af begrænsninger — en krop der føles tryg, og som hjem.",
  "company.why.overline": "Hvorfor os, hvorfor nu",
  "company.why.title": "Hvad vi skaber sammen — for jeres team.",
  "company.why.p1": "Som et team — Anthony og jeg — skaber vi en enestående mulighed for virksomheder for at investere i medarbejdernes sundhed og mentale velvære. Ikke en engangsworkshop. Ikke en statisk fitnessrabat. En levende praksis der følger jeres folk gennem arbejdsugen.",
  "company.why.p2": "Når de mennesker der bærer jeres virksomhed føler sig jordbundne i deres krop, skifter hele miljøet: en bedre virksomhedskultur, sundere medarbejdere der bidrager til bedre præstation, mere energi, skarpere fokus — og betydeligt færre sygedage.",
  "company.offer.overline": "Hvad der ligger i det",
  "company.offer.title": "En praksis hele jeres team kan komme hjem til — uanset hvor de arbejder fra.",
  "company.offer.c1.title": "Online sessioner",
  "company.offer.c1.body": "Designet omkring hver enkelt — deres mål, begrænsninger, stressniveau, tilgængelighed, livsstil, og om de træner i centeret eller hjemme.",
  "company.offer.c2.title": "Styrke, mobilitet & nervesystem",
  "company.offer.c2.body": "Styrke, mobilitet og nervesystem-støtte, designet til kroppe der sidder i mange timer og bærer stress. Vi fokuserer på at bygge ægte, varig modstandskraft der faktisk viser sig i hverdagen.",
  "company.offer.c3.title": "To trænere, én filosofi",
  "company.offer.c3.body": "Sammen har vi over 20 års erfaring inden for coaching og personlig træning, har hjulpet mere end 80.000 klienter, og fortsætter med at vokse — både som mennesker og trænere — for at tilbyde det højeste niveau af ekspertise og vejledning.",
  "company.addon.overline": "Valgfri tilføjelse",
  "company.addon.title.a": "Vil I have os i rummet?",
  "company.addon.title.b": "Book os personligt.",
  "company.addon.body": "Ud over online-programmet kan jeres virksomhed købe os til at komme og træne jeres team personligt — på kontoret, på en off-site, eller på en wellness-dag. Det er en tilføjelse til online-universet, prissat separat ud fra rejse og gruppestørrelse.",
  "company.addon.cta": "Spørg om personligt fremmøde",
  "company.outcomes.overline": "Hvad det bringer",
  "company.outcomes.title.a": "Præstation der holder.",
  "company.outcomes.title.b": "Sygedage der ikke gør.",
  "company.outcomes.li1": "Bedre virksomhedsmiljø — mere nærværende folk, mindre udbrændthed",
  "company.outcomes.li2": "Sundere medarbejdere — forbedret energi, fokus og humør",
  "company.outcomes.li3": "Stærkere præstation og bidrag på alle niveauer",
  "company.outcomes.li4": "Færre sygedage, stærkere fastholdelse, gladere teams",
  "company.contact.overline": "Få os ind",
  "company.contact.title": "Klar til at investere i jeres folk?",
  "company.contact.lead": "Tag fat i en af os — Sopfie eller Anthony — så vi kan tale om jeres team og hvad der vil tjene dem bedst.",
  "company.contact.cta": "Forhør for jeres team",
};

const translations = { en, da };
export default translations;
